import React from "react";

import "./footer.css";

export default function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/etashiro/weather-app-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>
      <span> by Erina Tashiro</span>
    </footer>
  );
}
